export default function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
// module id = 519
// module chunks = 0 1 2 3 4 5 6 7 8